import React, {useEffect} from 'react'
import './Roadbuddies.css'
import Androidscreenshoot from '../images/Roadbuddies/Androidscreenshoot.png'

import Artboard2 from '../images/Roadbuddies/Artboard2.png'
import Artboard3 from '../images/Roadbuddies/Artboard3.png'
import Artboard4 from '../images/Roadbuddies/Artboard4.png'
import Artboard5 from '../images/Roadbuddies/Artboard5.png'

import Footer from '../Component/footer'

function Roadbuddies() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       

        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-Roadbuddies">
        <div className="client-role-Roadbuddies">
            <h4 className="client-project-Roadbuddies">CLIENT</h4>
            <h2 className="portfolio-heading-Roadbuddies1"> Roadbuddies</h2>
            <h4 className="role-Roadbuddies">
            ROLE
            </h4>
            <h2 className="portfolio-role-Roadbuddies2">UI/UX Designer</h2>
           </div>
            <h4 className="client-details-Roadbuddies"> DETAILS
            </h4>
            <p className="client-details-Roadbuddies-p">
            - Collaborate with product owner, development and QA teams on the mockups and navigation flows.<br/>
        - Understand and work well with outputs from user and stakeholder research, being able to synthesize 
        insight to shape your design work and its outcomes.
            </p>

            <p className="client-details-Roadbuddies-p2">
           
            </p>
         </div>


         
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
        
       
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}

export default Roadbuddies
